import React, { useState } from 'react'

interface IProps {
  tabs: {
    name: string
    value: string
    onClick?: () => void
    component: React.ReactNode
  }[]
  initialTab?: string
}

const TabNavigation = ({ tabs, initialTab }: IProps) => {
  const [activeTab, setActiveTab] = useState(
    tabs.find((tab) => tab.value === initialTab) || tabs[0]
  )

  return (
    <>
      <div className='flex w-full border-b-2 border-border-default bg-background-chrome'>
        {tabs.map((tab) => (
          <button
            type='button'
            key={`tab-${tab.value}`}
            className={`flex flex-1 items-center justify-center border-b-4 px-4 py-2 transition-colors ${
              activeTab.value === tab.value
                ? 'border-border-brand text-text-brand'
                : 'border-transparent text-text-primary hover:text-text-brand'
            }`}
            onClick={() => {
              setActiveTab(tab)
              tab.onClick?.()
            }}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {activeTab.component}
    </>
  )
}

export default TabNavigation
